import { useContext } from 'react';
import { LocaleContext } from '../context/locale/context';

export const useTranslation = () => useContext(LocaleContext);
